import { render, staticRenderFns } from "./create_person_form.vue?vue&type=template&id=ec651be8&scoped=true"
import script from "./create_person_form.vue?vue&type=script&lang=ts"
export * from "./create_person_form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec651be8",
  null
  
)

export default component.exports